import JobBasicInfo from './JobBasicInfo.container';

export default JobBasicInfo;
